import { Suspense } from 'react';
import { Route } from 'react-router-dom';
import ErrorBoundary from '../components/ErrorBoundary/index';
import GlobalLoader from '../components/GlobalLoader/index';
import DynamicScreen from '../pages/config/DynamicScreen/index';
import { useTheme } from '../theme/theme-provider';
// import DynamicScreen from '../pages/config/DynamicScreen/index';

// Example route paths following SEO & search standards:
// - Use kebab-case for readability
// - Keep paths descriptive but concise
// - Include relevant parameters
// - Group related routes together
// - Avoid special characters except hyphens
// - Use semantic naming that describes the resource
//
// Examples:
// /settings/user-profile
// /reports/monthly-summary/:year/:month
// /dashboard/overview
// /orders/create
// /orders/:orderId/details
// /orders/:orderId/edit
// /products/categories/:categoryId
// /products/:productId/variants
// /customers/list
// /customers/:customerId/orders
// /analytics/sales/:startDate/:endDate
// /admin/users/permissions

const NewSrcRoutes = () => {
  const { theme } = useTheme();
  return (
    <div id='nsr-root' className={theme === 'dark' ? 'dark' : ''}>
      <ErrorBoundary>
        <Suspense fallback={<GlobalLoader loading={true} />}>
          <Route exact path='/nsr/create-rfq/:id/:type/:isCopy?'>
            <DynamicScreen screenComponentName='RFQCreate' />
          </Route>
          <Route exact path='/nsr/rfq-view/:id/:serviceType/:type'>
            <DynamicScreen screenComponentName='RFQCreate' />
          </Route>
          <Route exact path='/nsr/exim/rfq/create/:id/:type/:isCopy?'>
            <DynamicScreen screenComponentName='EximRFQCreate' />
          </Route>
          <Route exact path='/nsr/exim/rfq/view/:id/:serviceType/:type'>
            <DynamicScreen screenComponentName='EximRFQCreate' />
          </Route>
          <Route exact path='/nsr/seeker-home'>
            <DynamicScreen screenComponentName='SeekerHomeScreen' />
          </Route>
          <Route exact path='/nsr/rfq-dashboard'>
            <DynamicScreen screenComponentName='RfqDashboardScreen' />
          </Route>
          <Route exact path='/nsr/seeker-bids/:id/:type'>
            <DynamicScreen screenComponentName='BidDetailsScreen' />
          </Route>
          <Route exact path='/nsr/seeker-bids/:id/approval'>
            <DynamicScreen screenComponentName='BidDetailsScreen' />
          </Route>
          <Route exact path='/nsr/challenge-price-form/:id'>
            <DynamicScreen screenComponentName='ChallengePriceForm' />
          </Route>
          <Route exact path='/nsr/contract-records'>
            <DynamicScreen screenComponentName='ContractRecordsScreen' />
          </Route>
          <Route
            exact
            path='/nsr/contract-records/details/:id/:transporterId/:type'
          >
            <DynamicScreen screenComponentName='ContractRecordDetailsScreen' />
          </Route>
          <Route
            exact
            path='/nsr/seeker/bids/transporters/detail/:rfqId/:transporterId/:rfqType'
          >
            <DynamicScreen screenComponentName='TransporterBidDetailScreen' />
          </Route>
          <Route exact path='/nsr/route-master'>
            <DynamicScreen screenComponentName='RouteMasterScreen' />
          </Route>
          <Route exact path='/nsr/audit-dashboard'>
            <DynamicScreen screenComponentName='AuditDashboardScreen' />
          </Route>
          <Route exact path='/nsr/exim-cargo-tracking'>
            <DynamicScreen screenComponentName='EximCargoTrackingScreen' />
          </Route>
          <Route exact path='/nsr/dph-dashboard'>
            <DynamicScreen screenComponentName='DphDashboardScreen' />
          </Route>
          <Route exact path='/nsr/reports'>
            <DynamicScreen screenComponentName='ReportsScreen' />
          </Route>
          <Route exact path='/nsr/generate-contracts'>
            <DynamicScreen screenComponentName='GenerateContractsScreen' />
          </Route>
          <Route exact path='/nsr/view-generated-contracts'>
            <DynamicScreen screenComponentName='ViewGeneratedContractsScreen' />
          </Route>
          <Route exact path='/nsr/view-generated-contracts/create'>
            <DynamicScreen screenComponentName='CreateNewContractsScreen' />
          </Route>
          <Route exact path='/nsr/view-generated-contracts/details/:contractId'>
            <DynamicScreen screenComponentName='ViewContractDetailsScreen' />
          </Route>
          <Route exact path='/nsr/secondary-contracts'>
            <DynamicScreen screenComponentName='SecondaryContractsScreen' />
          </Route>
          <Route exact path='/nsr/secondary-contracts/create'>
            <DynamicScreen screenComponentName='AddEditSecondaryContractScreen' />
          </Route>
          <Route exact path='/nsr/secondary-contracts/view/:rfqId'>
            <DynamicScreen screenComponentName='AddEditSecondaryContractScreen' />
          </Route>
          <Route exact path='/nsr/secondary-contracts/edit/:rfqId'>
            <DynamicScreen screenComponentName='AddEditSecondaryContractScreen' />
          </Route>
          <Route exact path='/nsr/settings/groups-and-transporters/:type'>
            <DynamicScreen screenComponentName='GroupsAndTransportersScreen' />
          </Route>
          <Route exact path='/nsr/event-management'>
            <DynamicScreen screenComponentName='EventManagementScreen' />
          </Route>
          <Route exact path='/nsr/event-management/status/:eventId'>
            <DynamicScreen screenComponentName='EventStatusScreen' />
          </Route>
          <Route
            exact
            path='/nsr/event-management/winning-transporters/:eventId'
          >
            <DynamicScreen screenComponentName='WinningTransportersScreen' />
          </Route>
          <Route exact path='/nsr/event-management/create/:eventId/:rfqId'>
            <DynamicScreen screenComponentName='EventCreateScreen' />
          </Route>
          <Route exact path='/nsr/event-management/upload-rfqs/:eventId/:rfqId'>
            <DynamicScreen screenComponentName='EventUploadRfqsScreen' />
          </Route>
          <Route exact path='/nsr/event-management/preview/:eventId/:rfqId'>
            <DynamicScreen screenComponentName='EventPreviewScreen' />
          </Route>
          <Route
            exact
            path='/nsr/event-management/edit/:eventId/:rfqId/:parentId'
          >
            <DynamicScreen screenComponentName='EventRfqEditScreen' />
          </Route>
        </Suspense>
      </ErrorBoundary>
    </div>
  );
};

export default NewSrcRoutes;
